import { DateRange } from "react-day-picker";

import { ChartWrapper } from "./ChartWrapper";
import { useUsageChartsData } from "./hooks";

export const UsageCharts = ({ dateRange }: { dateRange: DateRange }) => {
  const { isLoading, usageTypes, processedData, totalOrganizationUsage } = useUsageChartsData({
    dateRange,
  });

  return (
    <div className="grid grid-cols-1 gap-6 xl:grid-cols-2">
      {usageTypes.map((usageType, index) => (
        <ChartWrapper
          key={usageType.key}
          title={usageType.title}
          description={usageType.description}
          isLoading={isLoading}
          className={`w-full ${index === 0 && usageTypes.length % 2 !== 0 ? "xl:col-span-2" : ""}`}
          usageType={usageType}
          processedData={processedData}
          totalOrganizationUsage={totalOrganizationUsage}
        />
      ))}
    </div>
  );
};
